import React from 'react';

const MainContainer = ({ children }) => {
  return <div className="flex-1 flex min-h-0 min-w-0 h-full bg-white">{children}</div>;
};

export default MainContainer;
